import { render, staticRenderFns } from "./categorie.vue?vue&type=template&id=1054c1d1&scoped=true"
import script from "./categorie.vue?vue&type=script&lang=js"
export * from "./categorie.vue?vue&type=script&lang=js"
import style0 from "./categorie.vue?vue&type=style&index=0&id=1054c1d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054c1d1",
  null
  
)

export default component.exports